import Navbar from '@/components/Navbar';
import Testimonials from '@/components/Testimonials';
import Footer from '@/components/Footer';

const TestimonialsPage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar onBookNow={() => {}} />
      
      {/* Page Header */}
      <section className="pt-32 pb-12 bg-gradient-to-b from-black to-[#0a0a0a]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Customer <span className="gold-gradient">Testimonials</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            See what our satisfied customers have to say about YYC Pick-Up
          </p>
        </div>
      </section>

      <Testimonials />
      <Footer />
    </div>
  );
};

export default TestimonialsPage;
